import { render, staticRenderFns } from "./EditaNiifNoControlante.vue?vue&type=template&id=62d481b0"
import script from "./EditaNiifNoControlante.vue?vue&type=script&lang=js"
export * from "./EditaNiifNoControlante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports